import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bgConstructorImportExport" }
const _hoisted_2 = {
  key: 0,
  viewBox: "0 0 512 512"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "m277 85l0 260 120-120 30 31-171 171-171-171 30-30 120 119 0-260z" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 0,
  viewBox: "0 0 512 512"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", { d: "m277 427l0-260 120 120 30-31-171-171-171 171 30 30 120-119 0 260z" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 1,
  class: "bgConstructorImportExport__downloadPopup"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_BgConstructorAddFloorOrWall = _resolveComponent("BgConstructorAddFloorOrWall")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Button, {
      onClick: _ctx.toggleDownloadPopup,
      class: "p-button p-component p-button-outlined p-button-danger"
    }, {
      default: _withCtx(() => [
        (!_ctx.state.isDownloading)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4))
          : _createCommentVNode("", true),
        (!_ctx.state.isDownloading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('bg_constructor.download')), 1))
          : _createCommentVNode("", true),
        (_ctx.state.isDownloading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('bg_constructor.downloading')), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_Button, {
      onClick: _ctx.toggleUploadPopup,
      class: "p-button p-component p-button-outlined p-button-danger"
    }, {
      default: _withCtx(() => [
        (!_ctx.state.isUploading)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_9))
          : _createCommentVNode("", true),
        (!_ctx.state.isUploading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('bg_constructor.upload')), 1))
          : _createCommentVNode("", true),
        (_ctx.state.isUploading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t('bg_constructor.uploading')), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onClick"]),
    (_ctx.isDownloadPopupShown)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "bgConstructorImportExport__downloadPopup_mask",
          onClick: _cache[0] || (_cache[0] = () => _ctx.toggleDownloadPopup())
        }))
      : _createCommentVNode("", true),
    (_ctx.isDownloadPopupShown)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = () => _ctx.downloadWallOrFloorImages('wall'))
          }, _toDisplayString(_ctx.$t('bg_constructor.wall_images')), 1),
          _createElementVNode("a", {
            onClick: _cache[2] || (_cache[2] = () => _ctx.downloadWallOrFloorImages('floor'))
          }, _toDisplayString(_ctx.$t('bg_constructor.floor_images')), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["bgConstructorImportExport__uploadPopup_mask", {
        'bgConstructorImportExport__uploadPopup_mask--hidden': !_ctx.isUploadPopupShown
      }]),
      onClick: _cache[3] || (_cache[3] = () => _ctx.toggleUploadPopup())
    }, null, 2),
    (!_ctx.uploadedFiles.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["bgConstructorImportExport__uploadPopup", {
        'bgConstructorImportExport__uploadPopup--hidden': !_ctx.isUploadPopupShown
      }])
        }, [
          _createElementVNode("a", {
            onClick: _cache[5] || (_cache[5] = () => _ctx.toggleUploadPopup())
          }, [
            _createElementVNode("label", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('bg_constructor.wall_images')), 1),
              _createElementVNode("input", {
                type: "file",
                multiple: "",
                onChange: _cache[4] || (_cache[4] = (e) => _ctx.uploadWallOrFloorImages('wall', e))
              }, null, 32)
            ])
          ]),
          _createElementVNode("a", {
            onClick: _cache[7] || (_cache[7] = () => _ctx.toggleUploadPopup())
          }, [
            _createElementVNode("label", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('bg_constructor.floor_images')), 1),
              _createElementVNode("input", {
                type: "file",
                multiple: "",
                onChange: _cache[6] || (_cache[6] = (e) => _ctx.uploadWallOrFloorImages('floor', e))
              }, null, 32)
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.uploadedFiles.length)
      ? (_openBlock(), _createBlock(_component_BgConstructorAddFloorOrWall, {
          key: 3,
          store: _ctx.store,
          state: _ctx.state,
          files: _ctx.uploadedFiles,
          "onUpdate:files": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.uploadedFiles) = $event)),
          target: _ctx.uploadedFilesTarget,
          "onUpdate:target": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.uploadedFilesTarget) = $event)),
          onUploadFinished: _cache[10] || (_cache[10] = () => (_ctx.uploadedFiles = []))
        }, null, 8, ["store", "state", "files", "target"]))
      : _createCommentVNode("", true)
  ]))
}